query ReferenceCodeList(
  $Ref1CodeFilter: Reference1CodeFilter
  $Ref2CodeFilter: Reference2CodeFilter
  $Ref3CodeFilter: Reference3CodeFilter
  $Ref4CodeFilter: Reference4CodeFilter
) {
  reference1Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref1CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
  reference2Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref2CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
  reference3Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref3CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
  reference4Codes(orderBy: REFERENCE_CODE_ASC, filter: $Ref4CodeFilter) {
    nodes {
      name
      referenceCode
    }
  }
}
